"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var renderCustomTooltip_1 = require("../../util/charts/renderCustomTooltip");
var hoursMinutesSeconds_1 = require("../../util/formatting/hoursMinutesSeconds");
var dateFormatter_1 = require("../../util/formatting/dateFormatter");
var luxon_1 = require("luxon");
var delimited_1 = require("../../util/formatting/delimited");
function createLineChartConfig(options) {
    var markers = formatLineStylesForConfig(options.lineStyles ? options.lineStyles : []);
    var timezone = options.timezone ? options.timezone : "UTC";
    function formatYAxis(value) {
        return options.metric === "count"
            ? "" + delimited_1.delimited({ value: value })
            : hoursMinutesSeconds_1.hoursMinutesSeconds(value, options.language);
    }
    function renderTooltip(data) {
        return renderCustomTooltip_1.renderCustomTooltip(data, options.metric, options.displayRange, options.language, timezone);
    }
    function formatXAxisLabels(value, timestamp) {
        return dateFormatter_1.formatDate(luxon_1.DateTime.fromMillis(timestamp), options.displayRange, "CHART", options.language, timezone);
    }
    var isAllZero = true;
    options.data.forEach(function (series) {
        for (var _i = 0, _a = series.data; _i < _a.length; _i++) {
            var datum = _a[_i];
            var value = datum[1];
            if (value > 0) {
                isAllZero = false;
                break;
            }
        }
    });
    var type = options.type ? options.type : "datetime";
    var baseConfig = {
        series: options.data,
        options: {
            plotOptions: {},
            colors: markers.strokes,
            legend: {
                show: false,
            },
            stroke: {
                width: isAllZero ? [0] : 1.5,
                colors: isAllZero ? ["#ffffff"] : markers.strokes,
            },
            xaxis: {
                type: type,
                labels: {
                    hideOverlappingLabels: true,
                    style: {
                        fontFamily: "Noto Regular, Noto Sans",
                        fontSize: 10,
                        colors: "#8f9399",
                    },
                    formatter: formatXAxisLabels,
                },
                axisBorder: {
                    color: "#dfe3e6",
                    height: 1,
                },
                axisTicks: {
                    color: "#dfe3e6",
                    height: 9,
                },
                tooltip: {
                    enabled: false,
                },
                crosshairs: {
                    show: !isAllZero,
                },
            },
            markers: {
                size: isAllZero ? [0] : markers.sizes,
                colors: isAllZero ? ["#ffffff"] : markers.fills,
                strokeColors: isAllZero ? ["#ffffff"] : markers.strokes,
                strokeWidth: isAllZero ? [0] : 1.5,
                shape: markers.shapes,
                fillOpacity: markers.opacities,
                radius: 0,
                hover: {
                    sizeOffset: 1.5,
                },
            },
            yaxis: {
                min: 0,
                tickAmount: 5,
                max: options.max ? options.max : undefined,
                forceNiceScale: options.max ? false : true,
                labels: {
                    style: {
                        fontFamily: "Noto Regular, Noto Sans",
                        fontSize: 10,
                        color: "#8f9399",
                    },
                    minWidth: options.metric === "time" ? 65 : 40,
                    formatter: isAllZero ? hideThings : formatYAxis,
                },
            },
            chart: {
                id: options.id,
                animations: {
                    enabled: true,
                    animateGradually: {
                        enabled: false,
                    },
                    dynamicAnimation: {
                        enabled: true,
                    },
                },
                toolbar: {
                    tools: {
                        download: false,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: true,
                    },
                },
                zoom: {
                    enabled: false,
                },
            },
            tooltip: {
                custom: isAllZero ? hideThings : renderTooltip,
            },
            states: {
                hover: {
                    filter: {
                        type: "none",
                        value: 0,
                    },
                },
            },
            language: options.language,
        },
    };
    if (options.annotations) {
        baseConfig.options["annotations"] = getAnnotations(options.annotations);
    }
    else {
        baseConfig.options["annotations"] = {
            position: "back",
        };
    }
    if (options.yAxisTitle) {
        baseConfig.options.yaxis["title"] = {
            text: options.yAxisTitle,
            rotate: 0,
            offsetY: -122,
            offsetX: 25,
            style: {
                fontFamily: "Noto Regular, Noto Sans",
                fontSize: 11,
                cssClass: "yaxis-title",
            },
        };
    }
    return baseConfig;
}
exports.createLineChartConfig = createLineChartConfig;
function formatLineStylesForConfig(markers) {
    var markerFills = [];
    var markerStrokes = [];
    var markerShapes = [];
    var markerOpacities = [];
    var markerSizes = [];
    markers.forEach(function (marker) {
        markerStrokes.push(marker.stroke);
        markerFills.push(marker.fill ? marker.fill : marker.stroke);
        markerShapes.push(marker.shape ? marker.shape : "circle");
        markerOpacities.push(marker.fillOpacity !== undefined ? marker.fillOpacity : 1);
        markerSizes.push(marker.shape === undefined || marker.shape === "circle" ? 3 : 5);
    });
    return {
        fills: markerFills,
        strokes: markerStrokes,
        shapes: markerShapes,
        opacities: markerOpacities,
        sizes: markerSizes,
    };
}
function hideThings() {
    return "";
}
function getAnnotations(annotationConfigs) {
    var annotations;
    if (annotationConfigs) {
        var xAxisAnnotations = annotationConfigs.filter(function (annotation) { return annotation.axis === "x"; });
        var yAxisAnnotations = annotationConfigs.filter(function (annotation) { return annotation.axis === "y"; });
        annotations = {
            position: "back",
        };
        if (xAxisAnnotations) {
            annotations.xaxis = xAxisAnnotations.map(function (annotation) { return ({
                x: annotation.start,
                x2: annotation.end,
                fillColor: annotation.fill,
                opacity: 0.6,
                label: { text: annotation.text ? annotation.text : " " },
            }); });
        }
        if (yAxisAnnotations) {
            annotations.yaxis = yAxisAnnotations.map(function (annotation) { return ({
                y: annotation.start,
                y2: annotation.end,
                fillColor: annotation.fill,
                opacity: 0.6,
                label: { text: annotation.text ? annotation.text : " " },
            }); });
        }
    }
    return annotations;
}
